import { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
let logoutTimer;

export const UniversalFunction = () => {
  const [Path, setPath] = useState("");
  const [token, setToken] = useState(false);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);
  const [Name, setName] = useState(false);
  const [Email, setEmail] = useState(false);
  const [AccountType, setAccountType] = useState(false);
  const [logoutTime, setlogoutTime] = useState(0);
  const history = useHistory();

  const login = useCallback(
    (uid, token, expirationDate, name, email, acType) => {
      setToken(token);
      setUserId(uid);
      setEmail(email);
      setName(name);
      setAccountType(acType);
      const tokenExpirationDate =
        expirationDate ||
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7);
      setTokenExpirationDate(tokenExpirationDate);
      localStorage.setItem(
        "userData",
        JSON.stringify({
          userId: uid,
          name: name,
          email: email,
          accountType: acType,
          token: token,
          expiration: tokenExpirationDate.toISOString(),
        })
      );
      history.push("/Dashboard");
    },
    [history]
  );

  const logout = useCallback(() => {
    setlogoutTime(logoutTime + 1);
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    localStorage.removeItem("userData");
    history.push("/");
  }, [logoutTime, history]);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userData"));
    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(
        storedData.userId,
        storedData.token,
        new Date(storedData.expiration),
        storedData.name,
        storedData.email,
        storedData.accountType
      );
    }
  }, [login]);

  const CheckNumberOnly = (val) => {
    const NumbOnly = new RegExp("^[0-9]*$");
    if (val === "") {
      return true;
    }
    return NumbOnly.test(val);
  };

  const GetMonth = (MonthNumb) => {
    if (MonthNumb === 1) return "January";
    else if (MonthNumb === 2) return "February";
    else if (MonthNumb === 3) return "March";
    else if (MonthNumb === 4) return "April";
    else if (MonthNumb === 5) return "May";
    else if (MonthNumb === 6) return "June";
    else if (MonthNumb === 7) return "July";
    else if (MonthNumb === 8) return "August";
    else if (MonthNumb === 9) return "September";
    else if (MonthNumb === 10) return "October";
    else if (MonthNumb === 11) return "November";
    else if (MonthNumb === 12) return "December";
    else return MonthNumb;
  };

  const cl = (txt) => {
    // console.log(txt);
  };

  const GetDate = (ThisDate) => {
    if (!CheckNumberOnly(ThisDate)) {
      ThisDate = parseInt(ThisDate, 16);
    }

    let StdDate = new Date(Number(ThisDate) * 1000);
    let RegDate = StdDate.getDate();
    let RegMonth = StdDate.getMonth() + 1;
    let RegYear = StdDate.getUTCFullYear();
    let RegHours = StdDate.getHours() % 12;
    if (RegHours === 0) {
      RegHours = 12;
    }
    // let RegMinutes =StdDate.getMinutes() < 10        ? "0" + StdDate.getMinutes(): StdDate.getMinutes();
    // let AMPMDecision = StdDate.getHours() > 12 ? "PM " : "AM ";

    return (
      GetMonth(RegMonth) + "," + RegDate + " " + RegYear
      // " - " +
      // RegHours +
      // "." +
      // RegMinutes +
      // AMPMDecision
    );
  };
  return {
    Path,
    setPath,
    cl,
    GetDate,
    token,
    userId,
    Name,
    Email,
    AccountType,
    logoutTime,
    login,
    logout,
  };
};
